import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CallService, IncomingCall, OutgoingCall } from '../../services/call.service';

@Component({
  selector: 'app-incoming-call',
  templateUrl: './incoming-call.html',
  styleUrls: ['./incoming-call.css'],
})
export class IncomingCallComponent implements OnInit, OnDestroy {
  call: IncomingCall | null = null;
  outgoing: OutgoingCall | null = null;
  private sub?: Subscription;
  private sub2?: Subscription;
  private ring = new Audio('assets/ringtone.mp3');
  private hideTimer: any;

  constructor(
    private callService: CallService,
    private router: Router
  ) {
    this.ring.loop = true;
  }

  ngOnInit() {
    this.sub = this.callService.incoming$.subscribe(c => {
      clearTimeout(this.hideTimer);
      this.call = c;

      if (c) {
        this.ring.play().catch(() => {});
        this.hideTimer = setTimeout(() => this.dismiss(), 30000);
      } else {
        this.stopRing();
      }
    });

    this.sub2 = this.callService.outgoing$.subscribe(o => this.outgoing = o);
  }

  async accept() {
    const c = this.call;
    if (!c) return;
    this.dismiss();
    try {
      const res = await this.callService.respond(c.invitation_id, 'accept');
      this.router.navigate(['/video-call', res.room_name]);
    } catch { /* caller ne pehle hi cancel kar diya */ }
  }

  async decline() {
    const c = this.call;
    if (!c) return;

    this.dismiss();

    await this.callService.respond(
      c.invitation_id,
      'decline'
    );
  }

  dismiss() {
    clearTimeout(this.hideTimer);
    this.call = null;
    this.stopRing();
  }

  private stopRing() {
    this.ring.pause();
    this.ring.currentTime = 0;
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.sub2?.unsubscribe();
    this.stopRing();
  }

  cancelOutgoing() { this.callService.cancelOutgoing(); }

}